import { FecImportLifecycleStatus } from '../enums/fecImportLifecycleStatus'
import type { FecImportItem } from '../query-api'

const IN_PROGRESS_STATUSES: ReadonlySet<FecImportLifecycleStatus> = new Set([
  FecImportLifecycleStatus.AwaitingProcessing,
  FecImportLifecycleStatus.DetectingMappings,
  FecImportLifecycleStatus.Parsing,
])

export const isFecImportInProgress = (fecImport: Pick<FecImportItem, 'status'>): boolean =>
  IN_PROGRESS_STATUSES.has(fecImport.status)
